import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { analyticsPush } from '../../actions/applicationActions';
import { EVT_SESSION_START } from '../../constants/EventTypes';
import { reportError } from '../../helpers/realUserMonitoring';
import { useGetUserInfo } from '../../hooks/useGetUserInfo';
import { hasValidVideolandCookie } from '../../helpers/authentication';

export function AnalyticsStarter({ children }) {
	const dispatch = useDispatch();
	const isAuthenticatedUser = hasValidVideolandCookie();

	const { loading: isUserLoading, user: { id: userId } = {} } = useGetUserInfo();

	const [isSessionStartDispatched, setIsSessionStartDispatched] = useState(false);

	useEffect(() => {
		try {
			if (isAuthenticatedUser && !isSessionStartDispatched && !isUserLoading) {
				dispatch(
					analyticsPush(
						{
							userId,
						},
						EVT_SESSION_START
					)
				);
				setIsSessionStartDispatched(true);
			}
		} catch (err) {
			reportError(err);
		}
	}, [dispatch, isSessionStartDispatched, isAuthenticatedUser, isUserLoading, userId]);

	return children;
}
